// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1ohCJ","content":"ManualTimeModal_content__iYep7"};